/* assets/zubehoer-guide.js — Zubehörführer Tarnnetz (DE) */
/* VARIANTS, P, FILETS, BASE sind via Liquid injiziert */

var TRI_SIZES=[
  {label:'2 × 2 × 2 m',sides:[2,2,2]},
  {label:'3 × 3 × 3 m',sides:[3,3,3]},
  {label:'3 × 4 × 5 m',sides:[3,4,5]},
  {label:'4 × 4 × 4 m',sides:[4,4,4]},
  {label:'5 × 5 × 5 m',sides:[5,5,5]}
];
var LABELS_MAP={
  'terrasse-mur':'Wandmontage',
  'pergola-bois':'Holzpergola',
  'pergola-metal':'Metallpergola / Aluminium',
  'terrasse-libre':'Freifläche',
  'arbres':'Zwischen Bäumen / Pfosten',
  'balcon':'Balkon / Geländer'
};
var a={structure:null,walls:null,shape:null,longueur:null,largeur:null,triSize:null,wallSide:null,coco:null,color:null};
var curStep='welcome';

function getSteps(){
  var steps=['welcome','structure'];
  if(a.structure==='terrasse-mur') steps.push('walls');
  steps.push('shape','size','coco');
  if(a.coco&&a.coco!=='coco') steps.push('color');
  steps.push('result');
  return steps;
}
function curIndex(){return getSteps().indexOf(curStep);}
function stepKey(step){return{structure:'structure',walls:'walls',shape:'shape',size:'size',color:'color',coco:'coco'}[step]||null;}
function sizeAnswered(){
  if(a.shape==='rect'){if(!a.longueur||!a.largeur) return false;if(needsWallSide()&&!a.wallSide) return false;return true;}
  return a.shape==='tri'&&a.triSize!==null;
}
function needsWallSide(){return a.structure==='terrasse-mur'&&a.walls==='1'&&a.shape==='rect'&&a.longueur&&a.largeur&&a.longueur!==a.largeur;}
function getSizeKey(){if(!a.longueur||!a.largeur) return null;var lo=Math.min(a.longueur,a.largeur),hi=Math.max(a.longueur,a.largeur);return lo+'x'+hi;}
function getTriKey(){if(a.shape!=='tri'||a.triSize===null) return null;return TRI_SIZES[a.triSize].sides.join('x');}
function getAvailableTypes(){
  var isTri=a.shape==='tri',types=[];
  if(isTri){var tk=getTriKey();if(!tk) return [];if(FILETS.renforce_tri[tk]) types.push('renforce');if(FILETS.coco_tri[tk]) types.push('coco');}
  else{var sk=getSizeKey();if(!sk) return [];if(FILETS.renforce_rect[sk]) types.push('renforce');var hC=Object.keys(FILETS.cable).some(function(k){return k.slice(k.lastIndexOf('_')+1)===sk;});if(hC) types.push('cable');if(FILETS.coco_rect[sk]) types.push('coco');}
  return types;
}

document.querySelectorAll('.op[data-q]').forEach(function(c){
  c.addEventListener('click',function(){
    var q=c.dataset.q,v=c.dataset.v;a[q]=v;
    document.querySelectorAll('.op[data-q="'+q+'"]').forEach(function(x){x.classList.remove('on');});
    c.classList.add('on');
    if(q==='structure'&&v!=='terrasse-mur') a.walls=null;
    if(q==='shape'){a.longueur=null;a.largeur=null;a.triSize=null;a.wallSide=null;}
    saveState();updateNav();
  });
});

function filterColorPanel(){
  var isTri=a.shape==='tri',sk=isTri?getTriKey():getSizeKey(),isCable=a.coco==='cable';
  var stockMap=isTri?FILETS.stock_tri:FILETS.stock_rect;var shown=0;
  document.querySelectorAll('.clr-op').forEach(function(el){
    var c=el.dataset.color,visible=true;
    if(isCable&&sk) visible=!!(FILETS.cable[c+'_'+sk]);
    else if(sk&&stockMap&&stockMap[c]) visible=!!(stockMap[c][sk]);
    el.style.display=visible?'':'none';if(visible) shown++;
    if(!visible&&a.color===c){a.color=null;el.classList.remove('on');}
  });
  var desc=document.querySelector('#p-color .sh p');
  if(desc) desc.textContent=shown+' Farbe'+(shown!==1?'n':'')+' für deine Größe verfügbar';
}
function pickColor(el){
  document.querySelectorAll('.clr-op').forEach(function(o){o.classList.remove('on');});
  el.classList.add('on');a.color=el.dataset.color;saveState();updateNav();
}

function populateFiletTypes(){
  var wrap=document.getElementById('filet-type-options');if(!wrap) return;
  var types=getAvailableTypes(),isTri=a.shape==='tri',h='';
  var typeMap={
    renforce:{icon:'i-filet-renforce',title:'Verstärktes Netz mit Polyesterseil',desc:'6mm Polyesterseil am gesamten Umfang'},
    cable:   {icon:'i-filet-cable',   title:'Verstärktes Netz mit Stahlseil',desc:'Beschichtetes Stahlseil am gesamten Umfang — besonders robust'},
    coco:    {icon:'i-filet-coco',    title:'Netz aus natürlichen Kokosfasern',desc:'Geflecht und Umfang aus 100% natürlichen Kokosfasern'}
  };
  if(types.length===0){
    h='<div class="tp"><div class="ti"><svg class="ico" style="width:14px;height:14px"><use href="#i-bulb"/></svg></div><div class="tt">Kein Netz für diese Größe verfügbar. <a href="'+BASE+'/collections/massgefertigte-netze" style="color:var(--cd);font-weight:700;">Maßanfertigung anfragen →</a></div></div>';
  } else {
    types.forEach(function(t){
      var tm=typeMap[t],productUrl=t==='cable'?FILETS.cable_url:t==='coco'?FILETS.coco_url:'';
      h+='<div class="op'+(a.coco===t?' on':'')+'" data-q="coco" data-v="'+t+'" data-purl="'+productUrl+'">'
        +'<div class="oi"><svg class="ico-scene" style="width:38px;height:34px"><use href="#'+tm.icon+'"/></svg></div>'
        +'<div class="ob"><div class="ot">'+tm.title+'</div><div class="od">'+tm.desc+'</div></div>'
        +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div></div>';
    });
  }
  wrap.innerHTML=h;
  wrap.querySelectorAll('.op[data-q]').forEach(function(c2){
    c2.addEventListener('click',function(){
      var q=c2.dataset.q,v=c2.dataset.v;if(q==='coco'&&a[q]!==v) a.color=null;
      a[q]=v;wrap.querySelectorAll('.op[data-q="'+q+'"]').forEach(function(x){x.classList.remove('on');});
      c2.classList.add('on');saveState();updateNav();
    });
  });
}

function goTo(step){
  var oldEl=document.getElementById('p-'+curStep);oldEl.classList.add('ou');
  setTimeout(function(){
    oldEl.classList.add('hd');oldEl.classList.remove('ou');curStep=step;saveState();
    if(curStep==='size') populateSizePanel();if(curStep==='coco') populateFiletTypes();
    if(curStep==='color') filterColorPanel();if(curStep==='result') bR();
    var newEl=document.getElementById('p-'+curStep);newEl.classList.remove('hd');newEl.classList.add('ou');
    requestAnimationFrame(function(){requestAnimationFrame(function(){newEl.classList.remove('ou');});});
    updateUI();window.scrollTo({top:0,behavior:'smooth'});
  },200);
}
function goNext(){var steps=getSteps();var i=curIndex();if(i<steps.length-1) goTo(steps[i+1]);}
function goPrev(){var steps=getSteps();var i=curIndex();if(i>0) goTo(steps[i-1]);}
function rs(){
  a={structure:null,walls:null,shape:null,longueur:null,largeur:null,triSize:null,wallSide:null,coco:null,color:null};
  document.querySelectorAll('.op,.clr-op').forEach(function(c){c.classList.remove('on');});
  document.getElementById('size-content').innerHTML='';
  try{sessionStorage.removeItem('tzgac');}catch(e){}goTo('welcome');
}

function updateNav(){
  var b=document.getElementById('bN'),steps=getSteps(),i=curIndex();
  if(curStep==='welcome'){b.disabled=false;b.innerHTML='Starten <svg class="ico" style="width:14px;height:14px"><use href="#i-right"/></svg>';return;}
  var key=stepKey(curStep),isLast=i===steps.length-2;
  b.disabled=curStep==='size'?!sizeAnswered():(key&&!a[key]);
  b.innerHTML=(isLast?'Mein Zubehör anzeigen ':'Weiter ')+'<svg class="ico" style="width:14px;height:14px"><use href="#i-right"/></svg>';
}
function updateUI(){
  var bnav=document.getElementById('bnav'),pa=document.getElementById('pA');
  if(curStep==='welcome'){pa.style.display='none';bnav.classList.add('hidden');}
  else if(curStep==='result'){pa.style.display='none';bnav.classList.add('hidden');}
  else{
    pa.style.display='block';
    var steps=getSteps(),qSteps=steps.filter(function(s){return s!=='welcome'&&s!=='result';});
    var qIdx=qSteps.indexOf(curStep)+1,qTotal=qSteps.length;
    document.getElementById('pL').textContent='Schritt '+qIdx+' / '+qTotal;
    var d='';for(var i=1;i<=qTotal;i++){d+='<div class="gac-sg '+(i<qIdx?'d':i===qIdx?'a':'')+'"></div>';}
    document.getElementById('pB').innerHTML=d;bnav.classList.remove('hidden');
  }
  document.getElementById('bB').style.display=curStep!=='welcome'?'':'none';updateNav();
}

function addToCart(items){
  var data=items.filter(function(x){return VARIANTS[x.k]>0;}).map(function(x){return{id:VARIANTS[x.k],quantity:x.q};});
  if(!data.length){window.location.href='/cart';return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:data})}).then(function(){window.location.href='/cart';}).catch(function(){window.location.href='/cart';});
}

function populateSizePanel(){
  var c=document.getElementById('size-content');
  if(a.shape==='rect'){
    var h='<div class="dim-row">';
    h+='<div class="dim-col"><label>Länge</label><select id="sel-long" onchange="onRectChange()"><option value="" disabled selected>— wählen —</option>';
    for(var i=2;i<=10;i++) h+='<option value="'+i+'"'+(a.longueur===i?' selected':'')+'>'+i+' m</option>';
    h+='</select></div>';
    h+='<div class="dim-col"><label>Breite</label><select id="sel-larg" onchange="onRectChange()"><option value="" disabled selected>— wählen —</option>';
    for(var j=2;j<=10;j++) h+='<option value="'+j+'"'+(a.largeur===j?' selected':'')+'>'+j+' m</option>';
    h+='</select></div></div>';
    h+='<div class="dim-info" id="dim-info" style="display:none"><svg class="ico" style="width:14px;height:14px"><use href="#i-ruler"/></svg><span id="dim-info-text"></span></div>';
    h+='<div id="wallside-wrap" style="display:none"></div>';
    c.innerHTML=h;
    if(a.longueur) updateSecondDropdown(a.longueur);
    if(a.longueur&&a.largeur) onRectChange();
  } else {
    var h2='<div class="dim-full"><label>Dreieck-Maße</label><select id="sel-tri" onchange="onTriChange()"><option value="" disabled selected>— wählen —</option>';
    TRI_SIZES.forEach(function(t,idx){h2+='<option value="'+idx+'"'+(a.triSize===idx?' selected':'')+'>'+t.label+'</option>';});
    h2+='</select></div>';
    h2+='<div class="dim-info" id="dim-info" style="display:none"><svg class="ico" style="width:14px;height:14px"><use href="#i-ruler"/></svg><span id="dim-info-text"></span></div>';
    c.innerHTML=h2;if(a.triSize!==null) onTriChange();
  }
}
function updateSecondDropdown(L){
  var sel=document.getElementById('sel-larg');if(!sel) return;
  sel.querySelectorAll('option').forEach(function(o){
    if(!o.value) return;var W=parseInt(o.value);var lo=Math.min(L,W),hi=Math.max(L,W),sk=lo+'x'+hi;
    var avail=!!(FILETS.renforce_rect[sk]||FILETS.coco_rect[sk]||Object.keys(FILETS.cable).some(function(k){return k.slice(k.lastIndexOf('_')+1)===sk;}));
    o.disabled=!avail;
  });
}
function onRectChange(){
  var selL=document.getElementById('sel-long'),selW=document.getElementById('sel-larg');
  var L=parseInt(selL.value)||0,W=parseInt(selW.value)||0;
  if(L) updateSecondDropdown(L);
  if(L&&W){
    a.longueur=L;a.largeur=W;var perim=2*(L+W),surf=L*W;
    var info=document.getElementById('dim-info');info.style.display='flex';
    document.getElementById('dim-info-text').innerHTML='<strong>'+L+' × '+W+' m</strong> — '+surf+' m² · Umfang '+perim+' m';
    showWallSideQuestion();
  }
  saveState();updateNav();
}
function wallSvg(wallOnSide1,L,W){
  var vW=58,vH=54,maxRW=32,maxRH=28,scale=Math.min(maxRW/L,maxRH/W);
  var rW=Math.max(14,Math.round(L*scale)),rH=Math.max(10,Math.round(W*scale));
  var rX=4,rY=Math.round((vH-rH)/2),x1=rX,y1=rY,x2=rX+rW,y2=rY+rH;
  var s='<svg width="52" height="48" viewBox="0 0 '+vW+' '+vH+'" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">';
  s+='<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y1+'" stroke-width="'+(wallOnSide1?'5':'1.5')+'" '+(wallOnSide1?'':'stroke-dasharray="3 2"')+'"/>';
  s+='<line x1="'+x1+'" y1="'+y2+'" x2="'+x2+'" y2="'+y2+'" stroke-width="1.5" stroke-dasharray="3 2"/>';
  s+='<line x1="'+x1+'" y1="'+y1+'" x2="'+x1+'" y2="'+y2+'" stroke-width="'+(wallOnSide1?'1.5':'5')+'" '+(!wallOnSide1?'':'stroke-dasharray="3 2"')+'"/>';
  s+='<line x1="'+x2+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke-width="1.5" stroke-dasharray="3 2"/>';
  s+='<text x="'+Math.round(x1+rW/2)+'" y="'+(y2+11)+'" text-anchor="middle" font-size="8" fill="currentColor" stroke="none" font-family="sans-serif" font-weight="700">'+L+' m</text>';
  s+='<text x="'+(x2+6)+'" y="'+Math.round((y1+y2)/2+3)+'" text-anchor="start" font-size="8" fill="currentColor" stroke="none" font-family="sans-serif" font-weight="700">'+W+' m</text>';
  return s+'</svg>';
}
function showWallSideQuestion(){
  var wrap=document.getElementById('wallside-wrap');if(!wrap) return;
  if(needsWallSide()){
    var L=a.longueur,W=a.largeur;
    var h='<div style="margin-top:16px;padding-top:16px;border-top:1.5px solid var(--bd)">';
    h+='<div style="font-size:15px;font-weight:700;margin-bottom:4px;color:var(--tx)">Welche Seite liegt an der Wand?</div>';
    h+='<div style="font-size:13px;color:var(--t3);margin-bottom:12px;">Dicker Strich = Wand · gestrichelt = freie Seite</div>';
    h+='<div class="os" style="margin-bottom:0">';
    h+='<div class="op'+(a.wallSide==='long'?' on':'')+'" onclick="pickWallSide(\'long\')" style="padding:14px 16px">'
      +'<div class="oi" style="width:48px;height:48px">'+wallSvg(true,L,W)+'</div>'
      +'<div class="ob"><div class="ot">Wand auf der '+L+' m Seite</div><div class="od">Die lange Seite liegt an der Wand — die '+W+' m Seite ist frei</div></div>'
      +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div></div>';
    h+='<div class="op'+(a.wallSide==='short'?' on':'')+'" onclick="pickWallSide(\'short\')" style="padding:14px 16px">'
      +'<div class="oi" style="width:48px;height:48px">'+wallSvg(false,L,W)+'</div>'
      +'<div class="ob"><div class="ot">Wand auf der '+W+' m Seite</div><div class="od">Die kurze Seite liegt an der Wand — die '+L+' m Seite ist frei</div></div>'
      +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div></div>';
    h+='</div></div>';
    wrap.innerHTML=h;wrap.style.display='block';
  } else {wrap.innerHTML='';wrap.style.display='none';a.wallSide=null;}
}
function pickWallSide(side){
  a.wallSide=side;var wrap=document.getElementById('wallside-wrap');
  wrap.querySelectorAll('.op').forEach(function(o){o.classList.remove('on');});
  if(side==='long') wrap.querySelectorAll('.op')[0].classList.add('on');
  else wrap.querySelectorAll('.op')[1].classList.add('on');
  saveState();updateNav();
}
function onTriChange(){
  var sel=document.getElementById('sel-tri'),idx=parseInt(sel.value);
  if(!isNaN(idx)){
    a.triSize=idx;var t=TRI_SIZES[idx],perim=t.sides.reduce(function(s,v){return s+v;},0);
    var info=document.getElementById('dim-info');info.style.display='flex';
    document.getElementById('dim-info-text').innerHTML='<strong>'+t.label+'</strong> — Umfang '+perim+' m';
  }
  saveState();updateNav();
}
function getDimensions(){
  if(a.shape==='rect'&&a.longueur&&a.largeur){var L=a.longueur,W=a.largeur;return{perim:2*(L+W),longest:Math.max(L,W),surface:L*W,sides:[L,W,L,W]};}
  if(a.shape==='tri'&&a.triSize!==null){var t=TRI_SIZES[a.triSize],p=t.sides.reduce(function(s,v){return s+v;},0);return{perim:p,longest:Math.max.apply(null,t.sides),surface:0,sides:t.sides};}
  return{perim:12,longest:4,surface:12,sides:[4,3,4,3]};
}
function pickRope(p){return p<=7.5?'corde75':p<=15?'corde15':'corde30';}
function pickCable(l){return l<=7.5?'cable75':l<=15?'cable15':'cable30';}
function intMats(len){return Math.max(0,Math.floor((len-1)/4));}

function bR(){
  var st=a.structure,w=parseInt(a.walls)||0,tri=a.shape==='tri',co=a.coco==='coco',isCable=a.coco==='cable';
  var dim=getDimensions(),perim=dim.perim,longest=dim.longest;
  var ess=[],opt=[],sd='';
  var tips=['Netz nicht zu straff spannen — etwas Spielraum erhöht die Windresistenz.','Die grobe Seite zeigt nach unten, die Seile nach oben.','25 cm weniger pro Seite als der reale Bereich wählen.','Im Frühjahr aufhängen und Ende Sommer abnehmen — verlängert die Lebensdauer.'];
  var cordeK=pickRope(perim),cableK=pickCable(longest),totalCorners=tri?3:4;
  var sizeLabel=tri?TRI_SIZES[a.triSize].label:(a.longueur+'×'+a.largeur+'m');

  if(st==='terrasse-mur'){
    var heldCorners=w===1?2:w===2?3:totalCorners,freeCorners=Math.max(0,totalCorners-heldCorners),qMat=0;
    if(w===1&&!tri){var wallLen=(a.wallSide==='long')?a.longueur:a.largeur,perpLen=(a.wallSide==='long')?a.largeur:a.longueur;if(!a.wallSide){wallLen=a.longueur;perpLen=a.largeur;}qMat=2+2*intMats(perpLen)+intMats(wallLen);}
    else if(w===1&&tri) qMat=1;
    else if(w===2&&!tri) qMat=1+intMats(a.longueur)+intMats(a.largeur);
    var qKit=w>=3?2:1;
    if(qKit>0) ess.push({k:'kit',q:qKit,w:qKit>1?'2 Sets für '+w+' Wände':'Netz an der Hauswand befestigen'});
    if(qMat>0){ess.push({k:'mat',q:qMat,w:qMat+' Mast'+(qMat>1?'en':'')});ess.push({k:'base',q:qMat,w:'1 Bodenhülse pro Mast — unbedingt erforderlich'});}
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    if(qMat>0) opt.push({k:'cliquets',q:1,w:'Schnellmontage und leichte Demontage'});
    opt.push({k:cableK,q:1,w:'Durchhängen in der Mitte vermeiden (Diagonale) oder als Führung'});
    sd=(w===1?'1 Seite an der Wand':w+' Seiten an der Wand')+(qMat>0?', '+qMat+' Mast'+(qMat>1?'en':'')+' für freie Seite'+(qMat>1?'n':'')+'.':' — keine Masten nötig.');
  } else if(st==='pergola-bois'){
    ess.push({k:'colliers',q:1,w:'Netz alle 10-15 cm an den Querbalken befestigen'});
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    opt.push({k:cableK,q:1,w:'Durchhängen vermeiden oder als Führung'});
    sd='Kabelbinder an der Holzstruktur + Seile für die Spannung.';
    tips.push('Kabelbinder alle 10-15 cm setzen, um Windsegel zu vermeiden.');
  } else if(st==='pergola-metal'){
    ess.push({k:'colliers',q:1,w:'Netz alle 10-15 cm an den Metallrohren befestigen'});
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    opt.push({k:cableK,q:1,w:'Durchhängen vermeiden oder als Führung'});
    sd='Kabelbinder an der Metallstruktur + Seile für die Spannung.';
  } else if(st==='terrasse-libre'){
    var qMatO=tri?totalCorners:4+2*intMats(a.longueur)+2*intMats(a.largeur);
    ess.push({k:'mat',q:qMatO,w:qMatO+' Masten für freistehende Konstruktion'});
    ess.push({k:'base',q:qMatO,w:'1 Bodenhülse pro Mast — unbedingt erforderlich'});
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    opt.push({k:'cliquets',q:1,w:'Schnellmontage und leichte Demontage'});
    opt.push({k:cableK,q:1,w:'Windabspannungen für die Masten oder Diagonale'});
    sd=qMatO+' Teleskopmasten mit Bodenhülsen — freistehende Montage.';
  } else if(st==='arbres'){
    ess.push({k:cableK,q:1,w:'Verbindungslinie zwischen den Bäumen / Pfosten'});
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    opt.push({k:'cliquets',q:1,w:'Schnellmontage und leichte Demontage'});
    sd='Stahlseil zwischen den Bäumen, Netz daran aufgehängt.';
  } else if(st==='balcon'){
    ess.push({k:'colliers',q:1,w:'Netz am Balkongeländer befestigen'});
    ess.push({k:cordeK,q:1,w:'Befestigungsseil — '+perim+'m Umfang'});
    sd='Befestigung am Geländer mit Nylon-Kabelbindern.';
  }

  if(co) opt.push({k:'cordecoco',q:1,w:'Natürliche Befestigung passend zum Kokosnetz'});
  opt.push({k:'borne',q:1,w:'Stimmungsvolle Solarbeleuchtung für die Nächte'});

  var seen={};function dd(ar){var r=[];ar.forEach(function(x){if(!seen[x.k]){seen[x.k]=1;r.push(x);}});return r;}
  ess=dd(ess);opt=dd(opt);
  if(isCable){opt=opt.filter(function(x){return x.k!==cableK;});if(!seen[cableK]){seen[cableK]=1;ess.push({k:cableK,q:1,w:'Stahlseil — tragende Hauptlinie deines Netzes'});}}
  var tE=0;ess.forEach(function(x){tE+=P[x.k].p*x.q;});
  var shapeLabel=tri?' (Dreieckig)':' (Rechteckig)';
  var filetUrl=a.color&&FILETS.colors[a.color]?(tri?FILETS.colors[a.color].tri_url:FILETS.colors[a.color].url):'';
  if(a.coco==='cable') filetUrl=FILETS.cable_url;if(a.coco==='coco') filetUrl=FILETS.coco_url;
  var h='';
  h+='<div class="sm"><div class="si"><svg class="ico" style="width:20px;height:20px"><use href="#i-info"/></svg></div><div class="sd2"><strong>'+LABELS_MAP[st]+' — '+sizeLabel+shapeLabel+'</strong><br>'+sd+'</div></div>';
  var fi=getFiletInfo();
  if(fi){
    h+='<div class="rc"><div class="rl re"><svg class="ico" style="width:13px;height:13px"><use href="#i-leaf"/></svg> Dein Netz</div>'
      +'<div class="pr pr-sel checked" data-bp="'+fi.price+'"'+(fi.vid?' data-fid="'+fi.vid+'"':'')+' onclick="toggleSel(event,this)">'
      +'<div class="ochk"><svg class="ico"><use href="#i-check"/></svg></div>'
      +(fi.img?'<div class="pi re"><img src="'+fi.img+'" alt=""></div>':'')
      +'<div class="pd"><div class="pn2">'+fi.name+'</div>'+(fi.size?'<div class="pw">'+fi.size+'</div>':'')+'</div>'
      +(fi.price?'<div class="pp">'+fm(fi.price)+'</div>':'')
      +(fi.url?'<a href="'+fi.url+'" target="_blank" class="voir-btn" onclick="event.stopPropagation()">Ansehen</a>':'')
      +'</div></div>';
  }
  if(ess.length){h+='<div class="rc"><div class="rl re"><svg class="ico" style="width:13px;height:13px"><use href="#i-checkcircle"/></svg> Empfohlen</div>';ess.forEach(function(x){h+=prRow(x,true);});h+='</div>';}
  if(opt.length){h+='<div class="rc"><div class="rl ro"><svg class="ico" style="width:13px;height:13px"><use href="#i-bulb"/></svg> Optional</div>';opt.forEach(function(x){h+=prRow(x,false);});h+='</div>';}
  h+='<div class="tot"><div class="strow total"><div class="stl">Gesamtauswahl</div><div class="stv" id="result-total">'+fm(tE)+'</div></div>'
    +'<div class="trust-row">'
    +'<div class="trust-badge"><svg class="ico" style="width:20px;height:20px;flex-shrink:0"><use href="#i-truck"/></svg><div><div class="trust-t">Versandkostenfrei 2–4 Werktage</div><div class="trust-s">Mit DHL oder DPD</div></div></div>'
    +'<div class="trust-div"></div>'
    +'<div class="trust-badge trust-pay-badge"><svg class="ico" style="width:20px;height:20px;flex-shrink:0"><use href="#i-lock"/></svg><div><div class="trust-t">Sichere Zahlung</div><div class="pay-logos">'
    +'<img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/visa.svg" class="pay-icon" alt="Visa">'
    +'<img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/mastercard.svg" class="pay-icon" alt="Mastercard">'
    +'<img src="https://api.iconify.design/logos:paypal.svg" class="pay-icon pay-logo-bg" alt="PayPal">'
    +'<img src="https://api.iconify.design/simple-icons:klarna.svg?color=%23000" class="pay-icon pay-logo-bg pay-klarna" alt="Klarna">'
    +'</div></div></div>'
    +'</div></div>';
  h+='<div class="cta-row"><button class="cta-main cta-outline" onclick="addToCartDrawer()"><svg class="ico" style="width:17px;height:17px"><use href="#i-cart"/></svg>In den Warenkorb</button><button class="cta-main green" onclick="buyNow()"><svg class="ico" style="width:17px;height:17px;stroke:#fff"><use href="#i-right"/></svg>Jetzt kaufen</button></div>';
  h+='<div class="res-nav"><button class="bt bt-g" onclick="rs()"><svg class="ico" style="width:13px;height:13px"><use href="#i-undo"/></svg> Nochmal beginnen</button><button class="bt bt-g" onclick="goPrev()"><svg class="ico" style="width:13px;height:13px;transform:rotate(180deg)"><use href="#i-right"/></svg> Zurück</button></div>';
  h+='<div class="it"><div class="ih"><svg class="ico" style="width:12px;height:12px"><use href="#i-book"/></svg> Installationstipps</div>';
  tips.forEach(function(t){h+='<div class="ir"><svg class="ico" style="width:10px;height:10px"><use href="#i-right"/></svg> '+t+'</div>';});h+='</div>';
  document.getElementById('p-result').innerHTML=h;updateTotal();
}

function piHtml(p){return p.img?'<img src="'+p.img+'" alt="">':'<svg class="ico" style="width:15px;height:15px"><use href="#'+p.i+'"/></svg>';}
function prRow(x,isEss){
  var p=P[x.k],lt=p.p*x.q,pi=isEss?'re':'ro';
  return '<div class="pr pr-sel'+(isEss?' checked':'')+'" data-k="'+x.k+'" data-bp="'+p.p+'" onclick="toggleSel(event,this)">'
    +'<div class="ochk"><svg class="ico"><use href="#i-check"/></svg></div>'
    +'<div class="pi '+pi+'">'+piHtml(p)+'</div>'
    +'<div class="pd"><div class="pn2">'+p.n+'</div>'+(x.w?'<div class="pw">'+x.w+'</div>':'')+'</div>'
    +'<div class="pqc" onclick="event.stopPropagation()">'
    +'<button class="qb" onclick="qDec(this)">−</button><span class="qn">'+x.q+'</span><button class="qb" onclick="qInc(this)">+</button>'
    +'</div><div class="pp">'+fm(lt)+'</div>'
    +'<a href="'+p.u+'" target="_blank" class="voir-btn" onclick="event.stopPropagation()">Ansehen</a></div>';
}
function getFiletInfo(){
  var isTri=a.shape==='tri',sk=isTri?getTriKey():getSizeKey();if(!sk||!a.coco) return null;
  var fi={url:'',img:'',name:'',size:'',price:0,vid:null};
  if(a.coco==='cable'&&a.color){var cv=FILETS.cable[a.color+'_'+sk];if(cv&&cv.id){fi.vid=cv.id;fi.price=cv.p;}fi.url=FILETS.cable_url;fi.img=FILETS.cable_img;fi.name='Tarnnetz Stahlseil — '+(FILETS.colors[a.color]?FILETS.colors[a.color].label:a.color);}
  else if(a.coco==='coco'){fi.url=FILETS.coco_url;fi.img=FILETS.coco_img;fi.name='Vorhang Kokosfasern';}
  else if(a.color&&FILETS.colors[a.color]){var vm=isTri?FILETS.stock_tri:FILETS.stock_rect,vd=vm[a.color]&&vm[a.color][sk];if(vd&&vd.id){fi.vid=vd.id;fi.price=vd.p;}fi.url=isTri?FILETS.colors[a.color].tri_url:FILETS.colors[a.color].url;fi.img=isTri?FILETS.colors[a.color].tri_img:FILETS.colors[a.color].img;fi.name='Tarnnetz '+FILETS.colors[a.color].label;}
  fi.size=isTri&&a.triSize!==null?TRI_SIZES[a.triSize].label:(a.longueur&&a.largeur?a.longueur+' × '+a.largeur+' m':'');
  return fi;
}
function addFiletToCart(){var fi=getFiletInfo();if(!fi) return;if(!fi.vid){if(fi.url) window.open(fi.url,'_blank');return;}fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:fi.vid,quantity:1}]})}).then(function(){window.location.href='/cart';}).catch(function(){if(fi.url) window.open(fi.url,'_blank');});}
function toggleSel(e,el){e.preventDefault();el.classList.toggle('checked');updateTotal();}
function qInc(btn){var r=btn.closest('.pr-sel'),s=r.querySelector('.qn'),q=parseInt(s.textContent)+1;s.textContent=q;r.querySelector('.pp').textContent=fm(parseFloat(r.dataset.bp)*q);updateTotal();}
function qDec(btn){var r=btn.closest('.pr-sel'),s=r.querySelector('.qn'),q=Math.max(1,parseInt(s.textContent)-1);s.textContent=q;r.querySelector('.pp').textContent=fm(parseFloat(r.dataset.bp)*q);updateTotal();}
function updateTotal(){var t=0;document.querySelectorAll('#p-result .pr-sel.checked').forEach(function(r){var q=r.querySelector('.qn')?parseInt(r.querySelector('.qn').textContent):1;t+=parseFloat(r.dataset.bp||0)*q;});var el=document.getElementById('result-total');if(el) el.textContent=fm(t);}
function doCartAdd(checkout){
  var direct=[],keyed=[];
  document.querySelectorAll('#p-result .pr-sel.checked').forEach(function(r){var q=r.querySelector('.qn')?parseInt(r.querySelector('.qn').textContent):1;if(r.dataset.fid) direct.push({id:parseInt(r.dataset.fid),quantity:q});else if(r.dataset.k) keyed.push({k:r.dataset.k,q:q});});
  var data=direct.concat(keyed.filter(function(x){return VARIANTS[x.k];}).map(function(x){return{id:VARIANTS[x.k],quantity:x.q};}));
  if(!data.length){return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:data})})
    .then(function(r){return r.json().then(function(j){return{ok:r.ok,body:j};});})
    .then(function(res){if(!res.ok){window.location.href='/cart';return;}window.location.href=checkout?'/checkout':'/cart';})
    .catch(function(){window.location.href='/cart';});
}
function addToCartDrawer(){doCartAdd(false);}
function buyNow(){doCartAdd(true);}
function fm(n){return n.toFixed(2).replace('.',',')+' €';}
function saveState(){try{sessionStorage.setItem('tzgac',JSON.stringify({a:a,step:curStep}));}catch(e){}}
function restoreState(){
  try{var raw=sessionStorage.getItem('tzgac');if(!raw) return false;var sv=JSON.parse(raw);if(!sv||!sv.step||sv.step==='welcome') return false;a=sv.a;curStep=sv.step;Object.keys(a).forEach(function(q){if(a[q]===null||a[q]===undefined) return;var el=document.querySelector('.op[data-q="'+q+'"][data-v="'+a[q]+'"]');if(el) el.classList.add('on');});if(a.color){var clrEl=document.querySelector('.clr-op[data-color="'+a.color+'"]');if(clrEl) clrEl.classList.add('on');}document.querySelectorAll('.pn').forEach(function(p){p.classList.add('hd');});var cur=document.getElementById('p-'+curStep);if(cur) cur.classList.remove('hd');if(curStep==='size') populateSizePanel();if(curStep==='coco') populateFiletTypes();if(curStep==='color') filterColorPanel();if(curStep==='result') bR();updateUI();return true;}catch(e){return false;}
}
if(!restoreState()) updateUI();
